var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4511 4.365C11.9385 3.77965 11.656 3.02805 11.6561 2.25H9.33859V11.55C9.32109 12.0534 9.10873 12.5303 8.74632 12.8801C8.38391 13.2299 7.89979 13.4253 7.39609 13.425C6.33109 13.425 5.44609 12.555 5.44609 11.475C5.44609 10.185 6.69109 9.2175 7.97359 9.615V7.245C5.38609 6.9 3.12109 8.91 3.12109 11.475C3.12109 13.9725 5.19109 15.75 7.38859 15.75C9.74359 15.75 11.6561 13.8375 11.6561 11.475V6.7575C12.5958 7.43239 13.7241 7.79448 14.8811 7.7925V5.475C14.8811 5.475 13.4711 5.5425 12.4511 4.365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTiktok);
export default __webpack_public_path__ + "static/media/header_tiktok.1889e193cf21617349b5d384d5dcd915.svg";
export { ForwardRef as ReactComponent };